/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Project_ContextInputs */



/**
* | output |
* | --- |
* | "Project Context" |
*
* @param {Ad_Section_Project_ContextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_project_context = /** @type {((inputs?: Ad_Section_Project_ContextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Project_ContextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contexte du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektkontext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contesto del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контекст проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contexto del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目背景")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの背景")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना संदर्भ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contexto do Projeto")
	return /** @type {LocalizedString} */ ("Project Context")
});